import { render, staticRenderFns } from "./TableValidators.vue?vue&type=template&id=c0a6e9e4&scoped=true&"
import script from "./TableValidators.vue?vue&type=script&lang=js&"
export * from "./TableValidators.vue?vue&type=script&lang=js&"
import style0 from "./TableValidators.vue?vue&type=style&index=0&id=c0a6e9e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a6e9e4",
  null
  
)

export default component.exports